function bindLiveCheckout(button) {
  if (!button || button.dataset.deBound === '1') return;
  button.dataset.deBound = '1';
  const status = button.closest('.cart__ctas')?.querySelector('[data-drop-engine-status]');
  const dropId = button.dataset.dropId;
  const dropProductId = String(button.dataset.dropProductId || '');
  const lineCount = Number(button.dataset.dropLineCount || 0);
  const quantity = Number(button.dataset.dropQuantity || 0);
  const formatMoney = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'EUR' }).format(Number(cents || 0) / 100);

  const paintTotal = cents => {
    document.querySelectorAll('[data-cart-subtotal]').forEach(el => {
      const value = formatMoney(cents);
      el.setAttribute('value', value);
      const bdi = el.querySelector('bdi');
      if (bdi) bdi.textContent = value;
    });
  };

  const setPaused = live => {
    const isLive = live?.status === 'LIVE';
    button.dataset.dropPaused = isLive ? '0' : '1';
    button.disabled = !isLive;
    if (!isLive) {
      const label = live?.status === 'PAUSED' ? 'DROP PAUSED' : live?.status === 'ENDED' ? 'DROP ENDED' : 'DROP NOT LIVE';
      if (status) status.textContent = label + ' — checkout is disabled for this item.';
    }
    return isLive;
  };

  async function loadState() {
    const [cartRes, liveRes] = await Promise.all([
      fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }),
      fetch('/apps/drop-engine/v1/drops/' + encodeURIComponent(dropId) + '/live', { cache: 'no-store' })
    ]);
    if (!cartRes.ok || !liveRes.ok) throw new Error('LIVE_UNAVAILABLE');
    const cart = await cartRes.json();
    const live = await liveRes.json();
    const dropItem = cart.items.find(i => String(i.product_id) === dropProductId);
    if (!dropItem) throw new Error('DROP_ITEM_NOT_FOUND');

    if (live.status !== 'LIVE') {
      paintTotal(Number(cart.total_price));
      setPaused(live);
      window.dispatchEvent(new CustomEvent('drop-engine:state', { detail: { dropId, ...live } }));
      return { cart, live };
    }

    const adjusted = Number(cart.total_price) - Number(dropItem.final_line_price) + Number(live.priceCents) * Number(dropItem.quantity);
    paintTotal(adjusted);
    setPaused(live);
    window.dispatchEvent(new CustomEvent('drop-engine:live', { detail: { dropId, ...live } }));
    button.dataset.expectedSlot = String(live.slot);
    button.dataset.livePrice = String(live.priceCents);
    return { cart, live };
  }

  async function refresh() {
    try {
      const { live } = await loadState();
      if (live.status === 'LIVE' && status) {
        status.textContent = 'Live checkout price ' + formatMoney(live.priceCents) + ' · confirmed when checkout opens.';
      }
    } catch {
      button.disabled = true;
      if (status) status.textContent = 'Live price unavailable. Checkout is temporarily disabled.';
    }
  }

  button.addEventListener('click', async () => {
    if (button.dataset.dropPaused === '1') return;
    if (lineCount !== 1 || quantity !== 1) {
      if (status) status.textContent = 'FIRST COME, FIRST SERVED™ items must be checked out one at a time.';
      return;
    }
    button.disabled = true;
    const original = button.querySelector('.button-text')?.textContent || 'Check out';
    const label = button.querySelector('.button-text');
    if (label) label.textContent = 'CONFIRMING LIVE PRICE…';
    try {
      const { cart, live } = await loadState();
      if (live.status !== 'LIVE') return;
      const response = await fetch('/apps/drop-engine/v1/checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          dropId,
          expectedSlot: Number(live.slot),
          items: cart.items.map(i => ({ variantId: i.variant_id, quantity: i.quantity }))
        })
      });
      const data = await response.json().catch(() => ({}));
      if (response.status === 409 && data.status === 'PRICE_MOVED') {
        if (status) status.textContent = 'PRICE MOVED — new live price ' + formatMoney(data.priceCents) + '. Tap checkout again to accept it.';
        window.dispatchEvent(new CustomEvent('drop-engine:refresh', { detail: { dropId } }));
        return;
      }
      if (!response.ok || !data.checkoutUrl) throw new Error(data.error || 'CHECKOUT_UNAVAILABLE');
      location.href = data.checkoutUrl;
    } catch (error) {
      if (status) {
        status.textContent = String(error?.message || '').includes('ADMIN_AUTH_REQUIRED')
          ? 'Drop checkout is being activated. Please try again shortly.'
          : 'Could not confirm the live price. Nothing was charged.';
      }
    } finally {
      if (label) label.textContent = original.trim();
      refresh();
    }
  });

  refresh();
  const timer = setInterval(() => {
    if (!document.contains(button)) {
      clearInterval(timer);
      return;
    }
    refresh();
  }, 8000);
}

const bindCheckouts = () => document.querySelectorAll('[data-drop-engine-checkout]').forEach(bindLiveCheckout);
bindCheckouts();
let frame;
new MutationObserver(() => {
  cancelAnimationFrame(frame);
  frame = requestAnimationFrame(bindCheckouts);
}).observe(document.body, { childList: true, subtree: true });
